import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import type { CartItem, CartResponse } from "@src/api/marketplace/cart";
import SidebarCartItem from "@src/pages/marketplace/shop/SidebarCartItem";

type SideBarCartProps = {
  cartResponse: CartResponse | undefined;
};

const SideBarCart: React.FC<SideBarCartProps> = ({ cartResponse }) => {
  const { t } = useTranslation();
  const allItems: CartItem[] = cartResponse?.vendors?.flatMap(v => v.items) ?? [];
  const subtotal = allItems
    .map(item => (item.amount * item.price.value) / 1000)
    .reduce((sum, amount) => sum + amount, 0)
    .toFixed(2);

  return (
    <>
      <div className="grid grid-flow-row text-center">
        <div className="text-sm"> {t("components.shared.subtotal")}</div>
        <div className="font-semibold">{subtotal} €</div>
      </div>

      <div className="w-full border-b border-gray-300 px-2 pb-3 pt-1">
        <NavLink
          className="flex w-full justify-center rounded-lg border border-gray-300 px-2 text-mini"
          to="/marketplace/offers/order/cart"
        >
          {t("buttons.goToCart")}
        </NavLink>
      </div>

      <div className="flex flex-row">
        <div className="h-[90vh] overflow-y-scroll">
          {allItems.map(item => (
            <div key={item.id}>
              <SidebarCartItem item={item} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SideBarCart;
